export default function removeCommas(str) {
  if (!str || str === "") return 0;
  return String(str).replace(/[A-Za-z,]/g, "");
}
